import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import SweetAlert from 'react-bootstrap-sweetalert';
import toastr from 'toastr';

import LangSelect from './LangSelect';
import { logout } from '../../api/auth';
import { logOutAction } from '../../redux/actions/auth';
import { getUser } from '../../api/user';


class Header extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      user: {},
      sweetAlert: false,
    };
  }

  async componentDidMount() {
    const { userId } = this.props;
    if (!userId) {
      toastr.error('ERR');
      const { dispatch, history } = this.props;
      logout();
      dispatch(logOutAction());
      history.push('/login');
      return;
    }
    const user = await getUser(userId).then((result) => ({ error: false, user: result.data.user }), (error) => {
      console.log('error', { error: true, errorMessage: error.message });
      return { error: true, errorMessage: error.message };
    });
    if (user.error) {
      toastr.error(user.errorMessage);
      const { dispatch, history } = this.props;
      logout();
      dispatch(logOutAction());
      history.push('/login');
      return;
    }
    this.setState({ user: user.user });
  }

  

  handleClick() {
    const { dispatch, history } = this.props;
    logout();
    dispatch(logOutAction());
    history.push('/login');
  }

  render() {
    const { user, sweetAlert } = this.state;
    const { name } = user;
    const { intl } = this.props;

    const syncItText = intl.formatMessage({ id: 'header.sendMenu.sync' });
    const areYouSureText = intl.formatMessage({ id: 'areyousure' });
    const cancelText = intl.formatMessage({ id: 'cancel' });

    return (
      <>
        <Wrapper>
          <LeftWrapper>
            <LangSelectWrapper>
              <LangSelect />
            </LangSelectWrapper>
          </LeftWrapper>

          <RightMenu>
            {
              name
                ? (
                  <WelcomeText>
                    <FormattedMessage id="header.welcomeText" />
                    ,
                    <ProfileLink to="/panel/profile">
                      {name}
                    </ProfileLink>
                  </WelcomeText>
                ) : ''
            }
            <LogoutButton onClick={this.handleClick}>
              <FormattedMessage id="header.logout" />
            </LogoutButton>
          </RightMenu>
        </Wrapper>
        <SweetAlert
          show={sweetAlert}
          warning
          showCancel
          cancelBtnText={cancelText}
          confirmBtnText={syncItText}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          title={areYouSureText}
          onConfirm={this.dataSync}
          onCancel={() => this.setState({ sweetAlert: false })}
        />
      </>
    );
  }
}

Header.defaultProps = {
  userId: null,
};

Header.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  intl: intlShape.isRequired,
};

const Wrapper = styled.div`
  width: calc(100% - 250px);
  margin-left: 250px;
  height: 65px;
  background-color: #fff;
  box-shadow: 0px 1px 5px -2px rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const RightMenu = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  padding: 10px;
  padding-right: 50px;
`;
const WelcomeText = styled.div`
  font-size: 1rem;
`;
const ProfileLink = styled(Link)`
  font-weight: 700;
  text-decoration: none !important;
  color: black;
  padding-left: 5px;
  :hover {
    color: black;
  }
`;
const LogoutButton = styled.button`
  border-radius: 4px;
  background: red;
  color: white;
  padding: 8px 12px;
  font-size: 0.8rem;
  margin-left: 10px;
  border-color: transparent;
  font-weight: 500;
`;
const SendDataButton = styled.button`
  border-radius: 4px;
  background: green;
  color: white;
  padding: 8px 12px;
  font-size: 0.8rem;
  margin-left: 10px;
  border-color: transparent;
  font-weight: 500;
  margin-left: 40px;
`;
const LangSelectWrapper = styled.span`
  padding-left: 20px;
`;

const mapStateToProps = (state, dispatch) => ({
  dispatch,
  userId: state.auth.user ? state.auth.user.id : '',
});
export default injectIntl(withRouter(connect(mapStateToProps)(Header)));
